module.exports = __webpack_public_path__ + "static/media/half-story.29c149ef.svg";